import React from 'react';
import { Grid, GridItem, Image, List } from '@landing/ui';

import * as styles from './ProgramItems.module.scss';

export default function ProgramItems({ items }) {
  const gridSettings = {
    xsm: { cols: 1, gutterX: '20px', gutterY: '20px' },
    sm: { cols: 1, gutterX: '20px', gutterY: '20px' },
    md: { cols: 2, gutterX: '20px', gutterY: '20px' },
    lg: { cols: 2, gutterX: '20px', gutterY: '20px' },
    xl: { cols: 2, gutterX: '20px', gutterY: '20px' },
  };

  return (
    <>
      {items.map(({ time, title, description, list, speakers }) => (
        <div key={time} className={styles.item}>
          <div className={styles.time}>{time}</div>
          <div className={styles.aboutItem}>
            <p className={styles.title}>{title}</p>
            {description && <p className={styles.description}>{description}</p>}
            {list && <List className={styles.list} items={list} />}
            {speakers && (
              <Grid {...gridSettings}>
                {speakers?.map(({ photo, name, company }) => (
                  <GridItem key={name} Tag="div">
                    <figure className={styles.speaker}>
                      <Image
                        src={photo}
                        alt={name}
                        className={styles.speakerPicture}
                        classImage={styles.speakerImg}
                      />
                      <figcaption>
                        <p className={styles.speakerName}>{name}</p>
                        {company && <p className={styles.speakerCompany}>{company}</p>}
                      </figcaption>
                    </figure>
                  </GridItem>
                ))}
              </Grid>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
